import { useCallback } from "react";

const buildEmptyRoom = (fields) =>
    Object.fromEntries(fields.map((f) => [f.name, ""]));

const useRoomChange = ({
    rooms,
    roomFields,
    roomTypeInfoByType,
    roomOfferByType,
    complementryByType,
    values,
    updateRoom,
    ensureTypeOptions,
}) => {
    const emptyRoom = buildEmptyRoom(roomFields);

    const handleRoomChange = useCallback(
        async (index, name, value) => {
            let next = { ...rooms[index], [name]: value };



            // room_id changed
            if (name === "room_id") {
                next = { ...emptyRoom, room_id: value };

                const fetched = await ensureTypeOptions(value, next, index);
                const details = fetched?.roomTypeInfo;
                const offerValue = fetched?.offerValue ?? 0;

                if (details) {
                    next = {
                        ...emptyRoom,
                        room_id: value,
                        room_rate: details.room_rate,
                        original_Rate: details.room_rate ?? 0,
                        extra_bed_charge: details.extra_bed_charge ?? 0,
                        extra_person_charge: details.extra_person_charge ?? 0,
                        extra_child_charge: details.extra_child_charge ?? 0,
                        extra_Capablity: details.exbed_capability ?? 0,
                        exbed_capability_limit: details.exbed_capability_limit ?? 0,
                        room_offer: offerValue,
                        capacity: details.capacity ?? 0,
                    };
                }

                updateRoom(index, next);
                return;
            }

            // room_no changed
            if (name === "room_no") {
                if (next.room_id) {
                    await ensureTypeOptions(next.room_id, next, index);
                }
            }

            // complementary_id changed
            if (name === "complementary_id") {
                const roomKey = `${next.room_id}_${index}`;
                const list = complementryByType[roomKey] || [];
                const hit = list.find((c) => String(c.complementary_id) === String(value));

                next = {
                    ...next,
                    complementary_id: hit?.complementary_id ?? null,
                    complementary_name: hit?.complementary_name ?? "",
                    complementary_price: hit?.complementary_price ?? 0,
                };
            }
            if (!next.extra_person_charge || !next.extra_bed_charge || !next.extra_child_charge) {
                const fetched = await ensureTypeOptions(value, next, index);
                const details = fetched?.roomTypeInfo;
                next = {
                    ...next,
                    extra_person_charge:Number(details.extra_person_charge),
                    extra_bed_charge:Number(details.extra_bed_charge),
                    extra_child_charge:Number(details.extra_child_charge)
                }
            }

            updateRoom(index, next);
        },
        [
            rooms,
            roomTypeInfoByType,
            roomOfferByType,
            complementryByType,
            values.checkin_date,
            values.checkout_date,
            updateRoom,
            ensureTypeOptions,
            emptyRoom,
        ]
    );

    return { handleRoomChange };
};

export default useRoomChange;
